import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaCommitDto } from '../../../../../../../models/ts/media-commit-dto.model';
import { FileUploadComponent } from '../../../../../../shared/components/file-upload/file-upload/file-upload.component';
import { CollectionFormField } from '../../../../../../../models/ts/collection-form-field.model';
import { BehaviorSubject } from 'rxjs';
import { ControlledDocumentUploadIntent } from './controlled-document-upload-intent';
import { ControlledDocumentTemplateIntent } from './controlled-document-template-intent';
import { FormControl } from '@angular/forms';
import { LinkedBaseFormControlComponent } from '../../../classes/linked-base-form-control.component';
import { selectForm } from 'src/app/store/features/forms/forms-selectors';
import { CollectionForm } from 'src/models/ts/collection-form.model';
import { FormType } from '../../../../../../../models/ts/form-type.model';

/**
 * Represents a control that allows the user to upload a document to BizzMine, specific to document collections.
 */
@Component({
  selector: 'bizz-controlled-document-control',
  standalone: true,
  imports: [CommonModule, FileUploadComponent],
  templateUrl: './controlled-document-control.component.html',
  styleUrls: ['./controlled-document-control.component.scss']
})
export class ControlledDocumentControlComponent extends LinkedBaseFormControlComponent<FormControl> {

  @Output() public fileChanged: EventEmitter<MediaCommitDto> = new EventEmitter<MediaCommitDto>();
  public uploadFile$: BehaviorSubject<ControlledDocumentUploadIntent | ControlledDocumentTemplateIntent | undefined> = new BehaviorSubject<ControlledDocumentUploadIntent | ControlledDocumentTemplateIntent | undefined>(undefined);

  public fileUploaded(file: MediaCommitDto | undefined): void {
    if (file) {
      this.formControl.setValue(file.MediasID);
      this.formControl.markAsDirty();
    }
    this.fileChanged.emit(file);
  }

  protected override fieldValueChangeComparator(previous: CollectionFormField | undefined, current: CollectionFormField | undefined): boolean {
    return JSON.stringify(current?.Value) == JSON.stringify(previous?.Value);
  }

  //Gets the form and checks if it is external or not by FormType
  public get isExternalForm (): boolean {
    const form = this.store$.selectSignal(selectForm(this.formId))()?.data;
    return !!(form && form.FormType === FormType.ExternalForm);
  }

  protected override valueSetter(field: CollectionFormField): void {
    const value = field[this.fieldValueProperty];
    if (value?.selectedTemplate != null || value?.files != null) {
      // do not actually SET value - instead, set the uploadFile$ subject -> starting an upload in the file-upload component
      if(value?.selectedTemplate != null){
        this.uploadFile$.next(value as ControlledDocumentTemplateIntent);
      }

      if(value?.files != null){
        this.uploadFile$.next(value as ControlledDocumentUploadIntent);
      }

      return;
    }
  }

  protected override focus(): void {
    // Add your implementation here
  }

  protected readonly FormType = FormType;
}

